var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bottom-border" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row remove-a" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(
              "router-link",
              {
                staticClass: "checkout-tab-button text-center",
                attrs: { to: { name: "vignette" } },
              },
              [_c("b", [_vm._v(_vm._s(_vm.$tc("vignetteWord", 1)))])]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c(
              "router-link",
              {
                staticClass: "checkout-tab-button text-center",
                attrs: { to: { name: "toll" } },
              },
              [_c("b", [_vm._v(_vm._s(_vm.$tc("tollWord", 1)))])]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }